import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'customerRangeFields',
    'customerRanges',
    'customerRangeTemplate',
    'customersUnitField',
    'messageFields',
    'notificationsPerUnitField',
  ];

  disableMessageField(event) {
    event.preventDefault();

    this.messageFieldsTarget.querySelectorAll('input').forEach((input) => {
      input.disabled = event.currentTarget.checked;
    });
  }

  enableCustomerRangeFields(event) {
    event.preventDefault();

    if (event.currentTarget.checked) {
      this.customerRangeFieldsTarget.classList.remove('hidden');
      this.customersUnitFieldTarget.disabled = true;
      this.notificationsPerUnitFieldTarget.disabled = true;
    } else {
      this.customerRangeFieldsTarget.classList.add('hidden');
      this.customersUnitFieldTarget.disabled = false;
      this.notificationsPerUnitFieldTarget.disabled = false;
    }
  }

  add() {
    const html = this.customerRangeTemplateTarget.innerHTML.replace(
      /__INDEX__/g,
      -Date.now(),
    );
    this.customerRangesTarget.insertAdjacentHTML('beforeend', html);
  }

  remove(event) {
    event.preventDefault();
    const element = event.currentTarget.closest('.customer-range');
    if (element) {
      element.remove();
    }
  }

  delete(event) {
    event.preventDefault();
    const element = event.currentTarget.closest('.customer-range');

    if (element) {
      element.querySelector('.customer-range-destroy').value = '1';
      element.style.display = 'none';
    }
  }
}
